export default {
  baseStyle: {
    fontSize: '1.2rem',
    fontWeight: 'normal',
    mb: 0.5,
  },
};
